import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  const [isDashboard, setIsDashboard] = useState(false);
  const [isProducts, setIsProducts] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isCustomers, setIsCustomers] = useState(false);
  const [isSuppliers, setIsSuppliers] = useState(false);
  const [isCategories, setIsCategories] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Products") {
      setIsProducts(false);
    }
    if (iscurrentState !== "Invoices") {
      setIsInvoices(false);
    }
    if (iscurrentState !== "Customers") {
      setIsCustomers(false);
    }
    if (iscurrentState !== "Suppliers") {
      setIsSuppliers(false);
    }
    if (iscurrentState !== "Categories") {  // Eklenen kontrol
      setIsCategories(false);
    }
  }, [history, iscurrentState]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/reform-dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "products",
      label: "Urunler",
      icon: "ri-product-hunt-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsProducts(!isProducts);
        setIscurrentState("Products");
        updateIconSidebar(e);
      },
      stateVariables: isProducts,
      subItems: [
        {
          id: "productList",
          label: "Urun Listesi",
          link: "/reform-products/list",
          parentId: "products",
        },
        {
          id: "productAdd",
          label: "Urun Ekle",
          link: "/reform-products/add",
          parentId: "products",
        },
      ],
    },
    {
      id: "invoices",
      label: "Teklif",
      icon: "ri-file-list-3-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsInvoices(!isInvoices);
        setIscurrentState("Invoices");
        updateIconSidebar(e);
      },
      stateVariables: isInvoices,
      subItems: [
        {
          id: "reforminvoiceList",
          label: "Teklif Listesi",
          link: "/reform-invoices/list",
          parentId: "invoices",
        },
        {
          id: "reforminvoiceDetail",
          label: "Teklif Yarat",
          link: "/reform-invoices/detail",
          parentId: "invoices",
        },
      ],
    },
    {
      id: "calendar",
      label: "Takvim",
      icon: "ri-calendar-2-line",
      link: "/reform-calendar",
    },
    {
      id: "customers",
      label: "Musteri",
      icon: "ri-user-2-line",
      link: "/reform-customers/list",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Customers");
        updateIconSidebar(e);
      },
      stateVariables: isCustomers,
    },
    {
      id: "categories",
      label: "Kategori",
      icon: "ri-list-check",
      link: "/reform-categories",
      click: function (e) {
        e.preventDefault();
        setIsCategories(!isCategories);
        setIscurrentState("Categories");
        updateIconSidebar(e);
      },
      stateVariables: isCategories,
    },
    {
      id: "personel",
      label: "Sirket Calisanlari",
      icon: "ri-map-pin-user-fill",
      link: "/reform-personel",
    },
    {
      id: "suppliers",
      label: "Tedarikci",
      icon: "ri-user-follow-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSuppliers(!isSuppliers);
        setIscurrentState("Suppliers");
        updateIconSidebar(e);
      },
      stateVariables: isSuppliers,
      subItems: [
        {
          id: "supplierList",
          label: "Supplier List",
          link: "/reform-suppliers/list",
          parentId: "suppliers",
        },
        {
          id: "supplierDetail",
          label: "Supplier Detail",
          link: "/reform-suppliers/detail",
          parentId: "suppliers",
        },
      ],
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;